import React from 'react'
import Section1 from './Section1'
import Section2 from './Section2'
import Section3 from './Section3'
import Section4 from './Section4'
import Section5 from './Section5'

import Header from '../Header'
import Footer from '../Footer'

export default () => (
  <div>
    <Header
      links={[
        { to: '/workforce/', label: 'Workforce' },

        { to: 'https://blog.sqrl.me', label: 'Blog' },
        { to: '/faqs/', label: 'FAQ' }
      ]}
    />
    <div className="app">
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
    </div>
    <Footer style={{ background: 'white' }} />
  </div>
)
